<template>
	<div>
		<ts-loading-banner :loading="loading">
			<form class="form-horizontal">
				<div class="row form-group">
					<label class="col-form-label col-md-4 required">{{
						$t('portfolioPhoto.setupDate')
					}}</label>
					<div class="col-md-6">
						<ts-date-picker-input v-model="model.setup_date">
						</ts-date-picker-input>
					</div>
					<div class="invalid-feedback" v-if="errors.has('setup_date')">
						{{ errors.first('setup_date') }}
					</div>
				</div>
				<div class="row form-group">
					<label class="col-form-label col-md-4 required">{{
						$t('portfolioPhoto.portfolioType')
					}}</label>
					<div class="col-md-6">
						<a-select v-model="model.portfolio_type_id" style="width: 100%" :options="portfolios"
							:show-search="true" option-filter-prop="children" :filter-option="(input, option) =>
								option.componentOptions.children[0].text
									.toLowerCase()
									.indexOf(input.toLowerCase()) >= 0
								"></a-select>
						<div class="invalid-feedback" v-if="errors.has('portfolio_type_id')">
							{{ errors.first('portfolio_type_id') }}
						</div>
					</div>
				</div>
				<div class="row form-group">
					<label class="col-form-label col-md-4 required">{{
						$t('portfolioPhoto.acYear')
					}}</label>
					<div class="col-md-6">
						<a-select v-model="model.ac_year_id" style="width: 100%" @change="onChangeYear" :options="years"
							:show-search="true" option-filter-prop="children" :filter-option="(input, option) =>
								option.componentOptions.children[0].text
									.toLowerCase()
									.indexOf(input.toLowerCase()) >= 0
								"></a-select>
						<div class="invalid-feedback" v-if="errors.has('ac_year_id')">
							{{ errors.first('ac_year_id') }}
						</div>
					</div>
				</div>
				<div class="row form-group">
					<label class="col-form-label col-md-4">{{
						$t('portfolioPhoto.term')
					}}</label>
					<div class="col-md-6">
						<a-select v-model="model.term_id" style="width: 100%" @change="onChangeTerm" :options="terms"
							:show-search="true" option-filter-prop="children" :filter-option="(input, option) =>
								option.componentOptions.children[0].text
									.toLowerCase()
									.indexOf(input.toLowerCase()) >= 0
								"></a-select>
					</div>
				</div>
				<div class="row form-group">
					<label class="col-form-label col-md-4">{{
						$t('portfolioPhoto.class')
					}}</label>
					<div class="col-md-6">
						<a-select v-model="model.class_id" style="width: 100%" :options="class_list" @change="onClassChange"
							:show-search="true" option-filter-prop="children" :filter-option="(input, option) =>
								option.componentOptions.children[0].text
									.toLowerCase()
									.indexOf(input.toLowerCase()) >= 0
								"></a-select>
					</div>
				</div>
				<div class="row form-group">
					<label class="col-form-label col-md-4">{{
						$t('portfolioPhoto.student')
					}}</label>
					<div class="col-md-6">
						<a-select v-model="model.student_id" style="width: 100%" :options="student_list" :show-search="true"
							option-filter-prop="children" :filter-option="(input, option) =>
								option.componentOptions.children[0].text
									.toLowerCase()
									.indexOf(input.toLowerCase()) >= 0
								"></a-select>
					</div>
				</div>
				<form class="form-horizontal">
					<fieldset>
						<legend>{{ $t('portfolioPhoto.attachmentFile') }}</legend>
						<AttachFile v-model="model" />
					</fieldset>
				</form>
				<div class="validate" v-if="errors.has('attach_file_list')">
					{{ errors.first('attach_file_list') }}
				</div>
				<div class="row">
					<div class="col-md-12 ts-mt-4 text-right">
						<ts-button class="ts-mr-2" @click.prevent="() => $emit('cancel')">
							{{ $t('cancel') }}
						</ts-button>
						<ts-button v-if="!isUpdate" :disabled="model.attach_file_list.length == 0" color="primary"
							:waiting="waiting" @click.prevent="save">{{
								$t('save') }}</ts-button>
						<ts-button v-if="isUpdate" color="primary" :disabled="model.attach_file_list.length == 0"
							:waiting="waiting" @click.prevent="onUpdate">{{
								$t('update') }}</ts-button>
					</div>
				</div>
			</form>
		</ts-loading-banner>
	</div>
</template>
  
<script>
import { Errors } from 'form-backend-validation'
import AttachFile from './attach-file.vue'
import moment from 'moment'
import { mapState } from 'vuex'
import { isEmpty } from "lodash";
export default {
	name: 'form',
	components: {
		AttachFile
	},
	data() {
		return {
			loading: false,
			waiting: false,
			class_list: [],
			student_list: [],
			terms: [],
			years: [],
			portfolios: [],
			errors: new Errors(),
			model: {
				upload_id: 0,
				student_id: null,
				class_id: null,
				setup_date: moment().format('DD-MM-YYYY'),
				portfolio_type_id: null,
				term_id: null,
				ac_year_id: null,
				attach_file_list: []
			}
		}
	},
	computed: {
		...mapState("portfolioPhoto", ["edit_data"]),
		isUpdate() {
			return !_.isEmpty(this.edit_data)
		}
	},
	created() {
		this.fetchYear()
		this.fetchPortfolio()
		this.onClassChange()
		this.onChangeYear()
		this.onChangeTerm()
		this.setEditData()
	},
	methods: {
		onClassChange() {
			if (!this.isEdit) {
				this.student_list = []
				this.model.student_id = null
			}
			this.loading = true
			this.$store
				.dispatch(
					'portfolioPhoto/getStudentEnrollmentByClass',
					this.model.class_id
				)
				.then(response => {
					this.student_list = response.data
						.filter(e => e.student_profile != null)
						.map(el => ({
							value: el.student_profile.student_id,
							label:
								el.student_profile.card_number +
								'|' +
								el.student_profile.full_name_en
						}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		fetchYear() {
			this.$store
				.dispatch('portfolioPhoto/getYear')
				.then(response => {
					this.years = response.data
						.map(el => ({
							value: el.ac_year_id,
							label: el.ac_year
						}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		fetchPortfolio() {
			this.$store
				.dispatch('portfolioPhoto/getPortfolio')
				.then(response => {
					this.portfolios = response.data.map(el => ({
						value: el.portfolio_type_id,
						label: el.portfolio_name_en
					}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		onChangeYear() {
			this.terms = []
			this.model.term_id = null
			this.loading = true
			this.$store
				.dispatch('portfolioPhoto/getTerm', this.model.ac_year_id)
				.then(response => {
					this.terms = response.data
						.map(el => ({
							value: el.ac_term_id,
							label: el.term_name
						}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		onChangeTerm() {
			this.class_list = []
			this.model.class_id = null
			this.loading = true
			this.$store
				.dispatch('portfolioPhoto/getClassOperation', this.model.term_id)
				.then(response => {
					this.class_list = response.data.map(el => ({
						value: el.class_id,
						label: el.class_name
					}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		save() {
			this.errors = new Errors()
			this.waiting = true
			this.$store
				.dispatch('portfolioPhoto/store', this.model)
				.then(response => {
					this.$toasted.success(response.message)
					this.$emit('fetchData')
					this.$emit('cancel')
				})
				.catch(error => {
					this.$toasted.error(error.message)
					this.errors = new Errors(error.errors)
				})
				.finally(() => {
					this.waiting = false
				})
		},
		onUpdate() {
			this.errors = new Errors()
			this.waiting = true
			this.$store
				.dispatch('portfolioPhoto/update', this.model)
				.then(response => {
					this.$toasted.success(response.message)
					this.$emit('fetchData')
					this.$emit('cancel')
				})
				.catch(error => {
					this.$toasted.error(error.message)
					this.errors = new Errors(error.errors)
				})
				.finally(() => {
					this.waiting = false
				})
		},
		setEditData() {
			if (!isEmpty(this.edit_data)) {
				this.model.upload_id = this.edit_data.upload_id
				this.model.portfolio_type_id = this.edit_data.portfolio_type_id
				this.model.ac_year_id = this.edit_data.ac_year_id
				this.model.term_id = this.edit_data.term_id
				this.model.class_id = this.edit_data.class_id
				this.model.student_id = this.edit_data.student_id
				this.model.setup_date = this.edit_data.setup_date
				this.model.attach_file_list = this.edit_data.gallery_photos.map(el => ({
					file_path: el.file_path,
					file_path: el.storage_path,
					original_file_name: el.original_file_name,
					remarks: el.remarks
				}))
			}
		}
	}
}
</script>

  